import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const InvalidDate = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="invalidDateDesc" /></Typography>
}

export default InvalidDate;